import React, { Component } from "react";
import { Card, Row, Col } from "antd";
import { Fragment } from "react";
import moment from "moment";

export default class ClaimsDetail extends Component {
  render() {
    const memberInformation = this.props.memberInformation;
    const paymentInformtaions = this.props.paymentInformtaions;
    return (
      <Fragment>
        <Card className="pr-2 pb-2 mb-2 pl-3">
          <div className="m-2 pt-1 details-header-sub">01. Member Information</div>
          <Row className="mt-4 mx-3">
            <Col span={5} className="details-header-row pr-1">
              Name <div className="black-text">{memberInformation.patientName ? memberInformation.patientName : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Address 01{" "}
              <div className="black-text">{memberInformation.addressLine1 ? memberInformation.addressLine1 : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Address 02{" "}
              <div className="black-text">{memberInformation.addressLine2 ? memberInformation.addressLine2 : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              City{" "}
              <div className="black-text">
              {memberInformation.city ? memberInformation.city : "---"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              State{" "}
              <div className="black-text" style={{ marginLeft: "2px" }}>
              {memberInformation.state ? memberInformation.state : "---"}
              </div>
            </Col>
          </Row>

          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              Country{" "}
              <div className="black-text">{memberInformation.country ? memberInformation.country : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Zip Code{" "}
              <div className="black-text">{memberInformation.zip ? memberInformation.zip : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Gender{" "}
              <div className="black-text">{memberInformation.gender}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              DOB{" "}
              <div className="black-text">
                {memberInformation.birthDate ? moment(memberInformation.birthDate, "YYYYMMDD").format("ll") : "---"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              Insured Name{" "}
              <div className="black-text">
              {memberInformation.insuredName ? memberInformation.insuredName : "---"}
              </div>
            </Col>
          </Row>
          <Row className="mt-4 pb-3 mx-3" >
            <Col span={5} className="details-header-row pr-1">
              Relationships to Insured{" "}
              <div className="black-text">{memberInformation.relationship ? memberInformation.relationship : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Insured's Unique Identifier{" "}
              <div className="black-text">{memberInformation.insuredUniqueNumber ? memberInformation.insuredUniqueNumber : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Insured's Group Name{" "}
              <div className="black-text">{memberInformation.insuredGroupName ? memberInformation.insuredGroupName : "---"}</div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              Insured's Group No.{" "}
              <div className="black-text">
              {memberInformation.insuredGroupNumber ? memberInformation.insuredGroupNumber : "---"}
              </div>
            </Col>
          </Row>
        </Card>

        {/* Second Div in payment tab */}

        <Card className="pr-2 pb-2 mb-2 pl-3 mt-3">
          <div className="m-2 pt-1 details-header-sub">02. Payer Information</div>
          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              Payer Name{" "}
              <div className="black-text">{paymentInformtaions.payerName ? paymentInformtaions.payerName : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Payer ID{" "}
              <div className="black-text">{paymentInformtaions.payerID ? paymentInformtaions.payerID : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Address 01{" "}
              <div className="black-text">{paymentInformtaions.payerAddress1 ? paymentInformtaions.payerAddress1 : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Address 02{" "}
              <div className="black-text">
              {paymentInformtaions.payerAddress2 ? paymentInformtaions.payerAddress2 : "---"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              City{" "}
              <div className="black-text">
              {paymentInformtaions.payerCity ? paymentInformtaions.payerCity : "---"}
              </div>
            </Col>
          </Row>

          <Row className="mt-4 mx-3 pb-3 " justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              State <div className="black-text">{paymentInformtaions.payerState ? paymentInformtaions.payerState : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Zip Code{" "}
              <div className="black-text">{paymentInformtaions.payerZipCode ? paymentInformtaions.payerZipCode : "---"}</div>
            </Col>
          </Row>
        </Card>

        {/* Third Div in payment tab */}
        {/* <Card className="pr-2 pb-2 mb-2 pl-3">
          <div className="m-2">03. Is Patient Condition Related to</div>
          <Row className="mt-4 ml-2" justify="space-between">
            <Col span={5} className="details-header-row">
              Employment:{" "}
              <div className="black-text">{"Rajat Bahndari"}</div>
            </Col>
            <Col span={5} push={1} className="details-header-row">
              Auto Accident:{" "}
              <div className="black-text">{"1044 Webster avenue"}</div>
            </Col>
            <Col span={5} push={1} className="details-header-row">
              Other Accident:{" "}
              <div className="black-text">{"1044 Webster avenue"}</div>
            </Col>
            <Col span={5} push={3} className="details-header-row">
              Accident Date:{" "}
              <div className="black-text" style={{ marginLeft: "2px" }}>
                {"Camdem"}
              </div>
            </Col>
            <Col span={5} push={4} className="details-header-row">
              Onset Date/Curr. Illness:{" "}
              <div className="black-text" style={{ marginLeft: "2px" }}>
                {"AR"}
              </div>
            </Col>
          </Row>
        </Card> */}
      </Fragment>
    );
  }
}
